<template>
  <div class="Linechart">
    <div id="main">

    </div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: ["zoushiList"],
  data() {
    return {
      yuqingOption: {
        backgroundColor: "#ffffff",
        legend: {
          
          show: true,
          // icon: "rect",
          itemWidth: 10,
          itemHeight: 5,
          itemGap: 0,
          right: "0%",
          top: "92%",
          textStyle: {
            fontSize: 12,
            color: "#C1C1C1"
          },
          
        },
        
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#C1C1C1"
            }
          }
        },
        grid: {
          top: "5%",
          left: "10%",
          right: "5%",
          bottom: "35%"
          // containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#C1C1C1"
              }
            },
            splitArea: {
              color: "#C1C1C1",
              lineStyle: {
                color: "#C1C1C1"
              }
            },
            axisLabel: {
              color: "#C1C1C1",
              // interval:0,
              rotate: 65
            },
            splitLine: {
              show: false
            },
            axisTick: {
              //横轴刻度的设置
              // show: false,
              color: "#C1C1C1"
            },
            boundaryGap: false,
            data: ["yuqingZoushiDate"] //['5/1', '6/1', '7/1', '8/1', '9/1', '10/1'],
          }
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            splitLine: {
              //刻度延长线
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#C1C1C1"
              }
            },
            axisLine: {
              //纵轴线的设置
              show: true,
              lineStyle: {
                color: "#C1C1C1"
              }
            },
            axisLabel: {
              //纵轴数值的设置
              // show: true,
              // margin: 20,
              textStyle: {
                color: "#C1C1C1" //'#d1e6eb',
              },
              formatter: function(value) {
                var texts = [];
                if (value < 1000) {
                  texts.push(value);
                }
                if (value >= 1000) {
                  value = value / 1000;
                  texts.push(value + "k");
                }
                return texts;
              }
            },
            axisTick: {
              //纵轴刻度的设置
              show: false
            }
          }
        ],
        series: [
          {
            name: "新闻",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: false,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: "circle",
            symbolSize: 2,
            lineStyle: {
              normal: {
                color: "#1B8EFF"
              }
            },
            itemStyle: {
              color: "#1B8EFF",
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#1B8EFF"
              }
            },
            tooltip: {
              show: true
            },
            data: ["yuqingZoushiNews"] //[502.84, 205.97, 332.79, 281.55, 398.35, 214.02, ]
          },
          {
            name: "微信",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: false,
            symbol: "circle",
            symbolSize: 2,
            lineStyle: {
              normal: {
                color: "#5CDBD3"
              }
            },
            itemStyle: {
              color: "#5CDBD3",
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#5CDBD3"
              }
            },
            tooltip: {
              show: true
            },
            data: ["yuqingZoushiWeixin"] //[281.55, 398.35, 214.02, 179.55, 289.57, 356.14, ],
          },
          {
            name: "微博",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: false,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: "circle",
            symbolSize: 2,
            lineStyle: {
              normal: {
                color: "#F4222E"
              }
            },
            itemStyle: {
              color: "#F4222E",
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#F4222E"
              }
            },
            tooltip: {
              show: true
            },
            data: ["yuqingZoushiWeibo"] //[251.55, 298.35, 274.02, 279.55, 239.57, 276.14, ],
          },
          {
            name: "论坛",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: false,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: "circle",
            symbolSize: 2,
            lineStyle: {
              normal: {
                color: "#9254DE"
              }
            },
            itemStyle: {
              color: "#9254DE",
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#9254DE"
              }
            },
            tooltip: {
              show: true
            },
            data: ["yuqingZoushiLuntan"] //[131.55, 208.35, 114.02, 159.55, 169.57, 206.14, ],
          },
          {
            name: "视频",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: false,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: "circle",
            symbolSize: 2,
            lineStyle: {
              normal: {
                color: "#3030ff"
              }
            },
            itemStyle: {
              color: "#3030ff",
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#3030ff"
              }
            },
            tooltip: {
              show: true
            },
            data: ["yuqingZoushiLuntan"] //[131.55, 208.35, 114.02, 159.55, 169.57, 206.14, ],
          },
          {
            name: "APP",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: false,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: "circle",
            symbolSize: 2,
            lineStyle: {
              normal: {
                color: "#ff3636"
              }
            },
            itemStyle: {
              color: "#ff3636",
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#ff3636"
              }
            },
            tooltip: {
              show: true
            },
            data: ["yuqingZoushiLuntan"] //[131.55, 208.35, 114.02, 159.55, 169.57, 206.14, ],
          },
          {
            name: "舆情数量",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: false,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: "circle",
            symbolSize: 2,
            lineStyle: {
              normal: {
                color: "#33ccff"
              }
            },
            itemStyle: {
              color: "#33ccff",
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#33ccff"
              }
            },
            tooltip: {
              show: true
            },
            data: ["yuqingZoushiLuntan"] //[131.55, 208.35, 114.02, 159.55, 169.57, 206.14, ],
          }
        ]
      }
    };
  },
  methods: {
    getoption() {
      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);

      this.yuqingOption && myChart.setOption(this.yuqingOption);
    }
  },
  watch: {
    zoushiList(newval) {
      if (newval) {
        let timearr = []; //时间
        let bbsarr = [];
        let total = [];
        let video = [];
        let Journalism = []; //新闻数据
        let weixin = []; //微信数据
        let weibo = []; //微博数据
        let app = [];

        newval.forEach((item, index) => {
          timearr.push(item.date); //时间
          total.push(item.total);
          bbsarr.push(item.bbsNum);
          weibo.push(item.microNum);
          Journalism.push(item.newsNum); //新闻数据
          weixin.push(item.weiXinNum);
          video.push(item.videoNum);
          app.push(item.appNum);
        });
        this.yuqingOption.xAxis[0].data = timearr;
        this.yuqingOption.series[0].data=Journalism
        this.yuqingOption.series[1].data=weixin
        this.yuqingOption.series[2].data=weibo
        this.yuqingOption.series[3].data=bbsarr
        this.yuqingOption.series[4].data=video
        this.yuqingOption.series[5].data=app
        this.yuqingOption.series[6].data=total
        console.log(this.yuqingOption);
        setTimeout(() => {
          this.getoption();
        }, 1000);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.Linechart {
  #main {
    width: 100%;
    height: 100%;
  }
}
</style>